import { render } from "./ConfigChanges.vue?vue&type=template&id=8c37e758&scoped=true"
import script from "./ConfigChanges.vue?vue&type=script&lang=js"
export * from "./ConfigChanges.vue?vue&type=script&lang=js"

import "./ConfigChanges.vue?vue&type=style&index=0&id=8c37e758&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c37e758"]])

export default __exports__